
export default {
  getName: (state) => state.name,

  getErrors: (state) => state.errors,
}